/* eslint-disable */
import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: { 
    },
    paper: {
      padding: theme.spacing(3)
    }
  })
);
